import { useParams } from "react-router-dom";
import "./post.css";
import api from "../../constants/api.js";
import { useEffect, useState } from "react";
import Carrossel from "../../componentes/carrossel/carrossel.jsx";

function Post() {
  const { id_post } = useParams();

  const [post, setPost] = useState(null);
  const [midiasFooter, setMidiasFooter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchDados() {
      try {
        setLoading(true);

        const [postRes, midiasRes] = await Promise.all([
          api.get(`/posts/${id_post}`),
          api.get(`/posts/${id_post}/midias-footer`) // ✅ ROTA CERTA
        ]);

        setPost(postRes.data);
        setMidiasFooter(midiasRes.data || []);
      } catch (err) {
        setError(err.response?.data?.error || "Erro ao buscar post");
      } finally {
        setLoading(false);
      }
    }

    fetchDados();
  }, [id_post]);

  if (loading) return <p>Carregando post...</p>;
  if (error) return <p>{error}</p>;
  if (!post) return <p>Post não encontrado</p>;

  function formatarData(data) {
    return new Date(data).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }

  return (
    <div className="container-post">
      <div className="post">
        {post.imagem_url && (
          <img src={post.imagem_url} alt={post.titulo} />
        )}

        <h1>{post.titulo}</h1>
        <p className="texto-post">{post.texto}</p>

        {post.created_at && (
          <div className="post-data">
            Data de publicação: {formatarData(post.created_at)}
          </div>
        )}
      </div>

      {/* 🔥 CARROSSEL FOOTER */}
      {midiasFooter.length > 0 && (
        <section className="post-footer-carousel">
          
          <Carrossel items={midiasFooter} tipo="midia" />
        </section>
      )}
    </div>
  );
}

export default Post;
